export default {
  light: {
    primary: "#ea5239",
    secondary: "#46474B",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#fbddd4"
  },
  vimelco: {
    primary: "#01A0A3",
    secondary: "#46474B",
    accent: "#006a7a",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#cceced"
  },
  sm: {
    primary: "#FF7900",
    secondary: "#46474B",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#FFE4CC"
  },
  nf: {
    primary: "#CF4520",
    secondary: "#4D4D4D",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#DDEEC5"
  },
  ugmk: {
    primary: "#f39420",
    secondary: "#46474B",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#fbddd4"
  },
  polymetal: {
    primary: "#ec9637",
    secondary: "#aaabaf",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#fbddd4"
  },
  global: {
    primary: "#ee6b4a",
    secondary: "#ec9637",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#fbddd4"
  },
  item: {
    primary: "#8340BD",
    secondary: "#46474B",
    accent: "#000000",
    background: "#ffffff",
    success: "#5AB55E",
    error: "#FF6060",
    light: "#fbddd4"
  }
};
